<template>
    <div v-if="contentRef" class="content-string-ref">
        <router-link
            v-if="contentRef.clientId"
            :to="{ name: 'client-content-strings-edit', params: { clientId: contentRef.clientId, contentId: contentRef.contentId } }"
        >{{contentRef.name}}</router-link>
        <router-link
            v-else
            :to="{ name: 'system-content-strings-edit', params: { contentId: contentRef.contentId } }"
        >{{contentRef.name}}</router-link>
        [{{contentRef.language}}]
        ({{contentRef.contentId}})
        <span v-if="contentRef.clientId">, client {{contentRef.clientId}}</span>
        <span class="tag del-btn" title="delete content reference" @click="deleteFunc()">del</span>
    </div>
</template>

<script>
export default {
    name: 'content-string-ref',
    props: {
        contentRef: {
            type: Object,
            required: true
        },
        deleteFunc: {
            type: Function,
            required: true
        }
    }
};
</script>

<style lang="scss">
.content-string-ref {
    padding: 0.28rem;
    a {
        margin-left: 0.2rem;
        margin-right: 0.2rem;
    }

    .del-btn {
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// front/src/components/common/content/string/content-string-ref.vue